#import "../fragments/prospector-saved-filter-fragment.graphql"

query GetProspectorSavedFilters {
    prospectorSavedFilters {
        ...ProspectorSavedFilterFragment
    }
}
